

import choose      from '../../fn/modules/choose.js';
import get         from '../../fn/modules/get.js';
import last        from '../../fn/modules/lists/last.js';
import parseInt    from '../../fn/modules/parse-int.js';
import toCamelCase from '../../fn/modules/to-camel-case.js';
import events      from '../../dom/modules/events.js';
import matches     from '../../dom/modules/matches.js';
import { trigger } from '../../dom/modules/trigger.js';
import merge       from '../../fn/stream/merge.js';
import rect        from '../../dom/modules/rect.js';
import style       from '../../dom/modules/style.js';
import { px }      from '../../dom/modules/parse-length.js';

function isVisible(element) {
    return element.offsetParent !== null;
}


/*
Add .stuck to site-nav to animate 'é' logo
*/

const sitenav    = document.getElementById('navigation');
const breakpoint = px('55rem');

merge([null], events('scroll resize', window))
.filter((e) => window.innerWidth >= breakpoint)
.map((e) => rect(sitenav).top <= 0)
.reduce((prev, value) => {
    if (prev !== value) {
        sitenav.classList[value ? 'add' : 'remove']('stuck');
    }

    return value;
// Use NaN as a seed as it is not equal to anything
}, NaN);



/*
.toggle-block
Enable toggle-block transitions of max-height to go to and from height: auto
for smoother opening and closing animations.
*/

events('dom-activate', document.body)
.map(get('target'))
.filter(matches('.nav-layer'))
.each(function(node) {
    // There are no transitions inside loading containers
    if (!isVisible(node) || matches('.loading .toggle-block', node)) {
        node.style.maxHeight = '';
        return;
    }

    // Deactivate other active nav-layers
    //trigger('dom-deactivate', node.parentNode.querySelector('.active'));

    const box       = node.getBoundingClientRect();
    const computed  = getComputedStyle(node);
    const lastChild = last(node.children);
    const bottom    = lastChild && lastChild.getBoundingClientRect().bottom;
    const height    = parseInt(computed.paddingBottom)
        + parseInt(computed.borderBottomWidth)
        + bottom
        - box.top;

    node.style.maxHeight = height + 'px';

    events('transitionend', node)
    .each(function(e) {
        node.style.maxHeight = '';
    });

    /* Attempt to stop the nav from jumping around */
    document.documentElement.style = 'scroll-padding-top: 0px;';
    window.location.hash = 'navigation';
});

const measure = choose({
    // Set maxHeight equal to height
    maxHeight: (node) => node.clientHeight + 'px',

    // Set all others to their computed values
    default: (node, style, property) => style[property]
});

events('dom-deactivate', document.body)
.map(get('target'))
.filter(matches('.nav-layer'))
.each(function(node) {
    const style = node.getAttribute('style');
    const computed = getComputedStyle(node);

    // Warning: this gets the transition-property before the class active has
    // been removed, which is not strictly speaking the intention. Ideally we
    // want computed styles from before, and transition-property from after.
    // Computed style is a live object, though. Handling this case risks being
    // expensive. So let us assume for the time being that transition-property
    // before and after class active are the same.
    const properties = computed['transition-property']
        .split(/\s*,\s*/)
        .map(toCamelCase);

    node.style.transition = 'none';
    properties.forEach((property) => node.style[property] = measure(property, node, computed, property));

    // Wait until the next frame to prevent
    requestAnimationFrame(function() {
        // Replace initial state of style attribute, if it's null remove it
        if (style) {
            node.setAttribute('style', style);
        }
        else {
            node.removeAttribute('style');
        }
    });

    /* Reset hash in a way that does not make the page jump */
    console.log(px('55rem'));
    if (window.innerWidth >= px('55rem')) {
        setTimeout(() => {
            console.log('HELLO');
            if (sitenav.querySelectorAll('.nav-layer.active').length === 0) {
                window.location.hash = '-';
            }
        }, 200);
    }
});


/* Attempt to stop the nav from jumping around */
events({ type: 'click', select: '[href="#navigation"]' }, document.body)
.each((e) => {
    document.documentElement.style = 'scroll-padding-top: 0px;';
});

events({ type: 'click', select: '[href="#-"]' }, document.body)
.each((e) => {
    document.documentElement.style = '';
});
